import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { XSolid } from '../../../icons/x-solid';
import { style } from './style';

type AccountEditPanelHeaderProps = {
  title: string,
  onCloseClick: () => void,
}

export const AccountEditPanelHeader = ({
  title,
  onCloseClick,
}:AccountEditPanelHeaderProps):JSX.Element => {
  return (
    <Box
      sx={ style.card.headerRow }
      onClick={ onCloseClick }
    >
      <Typography variant="h6">
        { title }
      </Typography>
      <Button
        sx={ {
          px: 0,
        } }
        color="inherit"
      >
        <XSolid
          fill="#fff"
        />
      </Button>
    </Box>
  );
};
